import classNames from 'classnames'
import { StatusColors, StatusType } from 'types/status'

interface IconButtonStatusProps {
  status?: StatusType
  statusCustomClass?: string
}

const IconButtonStatus = ({
  status,
  statusCustomClass,
}: IconButtonStatusProps) => {
  if (!status) return null

  return (
    <span
      className={classNames(
        'absolute top-0 left-3 w-2 h-2 rounded-full shadow-md',
        StatusColors[status],
        statusCustomClass
      )}
    ></span>
  )
}

export default IconButtonStatus
